const account = {
  serverUrl: 'https://dvagent-server.digivalet.com',
  version: "1.2.1"
};

export default account;
